/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './TalonOneRewards-ActionTypes';

export const fetchTalonOneRewards = () => ({
    type: actionTypes.FETCH_TALON_ONE_REWARDS,
});

export const fetchTalonOneRewardsSuccess = (data) => ({
    type: actionTypes.FETCH_TALON_ONE_REWARDS_SUCCESS,
    data,
});

export const fetchTalonOneRewardsFailure = (error) => ({
    type: actionTypes.FETCH_TALON_ONE_REWARDS_FAILURE,
    error,
});

export const clearTalonOneRewards = () => ({
    type: actionTypes.CLEAR_TALON_ONE_REWARDS,
});
